import React from 'react'
import DrawerView from 'core-system/Drawer/Drawer'
import CancelIcon from '@mui/icons-material/Cancel'
import IconButton from '@mui/material/IconButton'
import palette from 'core-system/Themes/palette'
import Text from 'core-system/Text/Text'
import styled from 'styled-components'

export const DrawerWidth = '65rem'

const DrawerInnerContainer = styled.div`
  padding: 1.5rem;
  width: 100%;
  height: 100%;
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
`

const RightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

interface SegmentsDrawerProps {
  title: string
  open: boolean
  onCloseModal: () => void
  children: React.ReactNode
  titleRightComponent?: React.ReactNode
}

const SegmentsDrawer = (props: SegmentsDrawerProps) => {
  const { title, open, onCloseModal, children, titleRightComponent } = props
  const Title = () => {
    return (
      <TitleContainer>
        <Text variant='action1'>{title}</Text>
        <RightContainer>
          {titleRightComponent}
          <IconButton onClick={onCloseModal}>
            <CancelIcon style={{ color: palette.text.primary }} />
          </IconButton>
        </RightContainer>
      </TitleContainer>
    )
  }

  return (
    <DrawerView width={DrawerWidth} isOpen={open} onClose={onCloseModal}>
      <DrawerInnerContainer>
        <Title />
        {children}
      </DrawerInnerContainer>
    </DrawerView>
  )
}

export default SegmentsDrawer
